import React from "react";
import { Space, Select, Typography } from "antd";

const { Text } = Typography;

const WarehouseFilters = ({ filterStatus, onStatusChange }) => {
  const statusOptions = [
    { value: "", label: "All Statuses" },
    { value: "Pending", label: "Pending" },
    { value: "In Progress", label: "In Progress" },
    { value: "Ready", label: "Ready" },
    { value: "Notified", label: "Notified" },
    { value: "Partially Collected", label: "Partially Collected" },
    { value: "Completed", label: "Completed" },
  ];

  return (
    <Space size="large">
      <Space>
        <Text>Status:</Text>
        <Select
          value={filterStatus}
          onChange={onStatusChange}
          options={statusOptions}
          style={{ width: 200 }}
        />
      </Space>
    </Space>
  );
};

export default WarehouseFilters;
